import { render } from "./registration-result.vue?vue&type=template&id=1ac7dab0&ts=true"
import script from "./registration-result.vue?vue&type=script&lang=ts"
export * from "./registration-result.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__